import { useSelector } from 'react-redux';
import screenFinder from '../../../../../constants/screens/screenFinder';
import GlobalSubTopBar from '../../../../../utils/components/GlobalSubTopBar';
import { collectionsSteps } from '../../../../../constants/screens/screensSteps';

function CreateCollectionTopBar({ isAgentScreen = false }) {
  const currentStep = useSelector(state => state.collectionsV1.etc.collectionsStep);
  const data = screenFinder('recirculations');
  const creationType = useSelector(state => state.collectionsV1.etc.creationType);

  return (
    <GlobalSubTopBar
      data={data}
      currentStep={currentStep}
      backRoute={data.dashboardPath}
      steps={collectionsSteps}
      creationType={creationType}
      isAgentScreen={isAgentScreen}
    />
  );
}

export default CreateCollectionTopBar;
